import { render } from "./QwilrDataSource.vue?vue&type=template&id=132063d2"
import script from "./QwilrDataSource.vue?vue&type=script&lang=js"
export * from "./QwilrDataSource.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__